import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import {
  Input,
  Button,
  Segment,
  Loader,
  Icon,
  Checkbox,
  Divider,
} from "semantic-ui-react"
import firebase from "../config/firebaseConfig"
import { useSelector, useDispatch } from "react-redux"
import {
  getUserInfo,
  register,
  exportSaveErrMsg,
  exportSaveScssMsg,
} from "../ducks/profile"
import ECPcomponent from "./ECPcomponent"
import { showMessage } from "../ducks/alerts"
import { useHistory } from "react-router-dom"

const RegistrationComponent = (props) => {
  const [step, setStep] = useState(0)
  const [x509, setX509] = useState("")
  const [iinOrBin, setIinOrBin] = useState("")
  const [number, setNumber] = useState("")
  const [active, setActive] = useState(false)
  const [login, setLogin] = useState("")
  const [pass, setPass] = useState("")
  const [confirmPass, setConfirmPass] = useState("")
  const [company, setCompany] = useState("")
  const [address, setAddress] = useState("")
  const [fio, setFio] = useState("")
  const [enterCode, setEnterCode] = useState(false)
  const [code, setCode] = useState("")
  const [codeConfirmed, setCodeConfirmed] = useState(false)
  const [email, setEmail] = useState("")
  const [checked, setChecked] = useState(false)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { profile, errMsg, scssMsg, alerts } = useSelector((state) => ({
    profile: state.profile,
    errMsg: state.profile.errMsg,
    scssMsg: state.profile.scssMsg,
    alerts: state.alerts,
  }))
  const { history } = props
  const getInfo = (value) => {
    if (value.length === 12) {
      onGetUserInfo(value)
    }
  }
  const onExportSaveScssMsg = (text) => {
    dispatch(exportSaveScssMsg(text))
  }
  const onExportSaveErrMsg = (text) => {
    dispatch(exportSaveErrMsg(text))
  }
  const implementInformation = (obj) => {
    setCompany(obj.name)
    setAddress(obj.katoAddress)
    setFio(obj.fio)
  }
  const onGetUserInfo = (value) => {
    dispatch(getUserInfo(value, implementInformation))
  }
  const onShowMessage = (m, t) => {
    dispatch(showMessage(m, t))
  }
  const onRegister = (data) => {
    dispatch(register(data, props))
  }
  const handleSubmit = () => {
    const data = {
      login,
      pass,
      passConfirm: confirmPass,
      company,
      address,
      bin: iinOrBin,
      fio,
      phoneNumber: parseInt(number),
      x509,
      mail: email,
    }
    onRegister(data)
  }
  useEffect(() => {
    return () => {}
  }, [])
  return (
    <>
      <div>
        {step === 0 && (
          <>
            <div>
              <div>
                <h3>{t("Step") + " 1"}</h3>
                <h5>{t("Company information")}.</h5>
              </div>
              <Divider />
              <h4>{t("IIN/BIN of organization")}:</h4>
              <div>
                <Input
                  fluid
                  size="small"
                  placeholder={t("IIN")}
                  value={iinOrBin}
                  onChange={(e, d) => {
                    setIinOrBin(d.value)
                    getInfo(d.value)
                    setActive(true)
                  }}
                  type="number"
                />
              </div>
            </div>
            {!errMsg && !scssMsg && active ? (
              <>
                <div>
                  <p>{t("Legal verification")}</p>
                  <Segment
                    style={{
                      border: "0px solid red",
                      boxShadow: "0 0",
                    }}
                  >
                    <Loader active />
                  </Segment>
                </div>
              </>
            ) : (
              <></>
            )}
            {errMsg && (
              <>
                <p style={{ color: "red" }}>{errMsg}</p>
                <div
                  style={{
                    border: "1px solid grey",
                    padding: "3px 5px",
                  }}
                >
                  <p
                    align="justify"
                    style={{
                      fontSize: "13px",
                    }}
                  >
                    {t(
                      'According to the Law of the Republic of Kazakhstan dated March 29, 2016 "On Amendments and Additions to Certain Legislative Acts of the Republic of Kazakhstan on the Issues of Reducing Permitting Documents and Simplifying Permitting Procedures", registration as an individual entrepreneur is carried out on the electronic licensing portal',
                    )}
                  </p>
                  <Button
                    content={t("Become an entrepreneur")}
                    color="green"
                    style={{ marginBottom: "2px" }}
                    onClick={() =>
                      window.open(
                        'https://elicense.kz/LicensingContent/Passport?servicesType=El4&servicesParameters=%7B"PackageCode"%3A"2016.МФ.У3"%2C"ServiceCode"%3A"2016.МФ.У3_1"%2C"VersionPackage"%3A"1.0.0"%2C"OperationTypeId"%3A"1"%2C"ActivityTypeCode"%3A"EL4-U16_MF3-V1"%2C"SubActivityTypeCode"%3A"EL4-U16_MF3-V1-P1"%7D',
                      )
                    }
                  />
                </div>
              </>
            )}
            <p style={{ color: "green" }}>{scssMsg}</p>
            {scssMsg ? (
              <>
                <div style={{ marginTop: 10 }}>
                  <h4>{t("fio")}:</h4>
                  <div>
                    <Input
                      fluid
                      size="small"
                      placeholder={t("fio")}
                      value={fio}
                      disabled
                    />
                  </div>
                </div>
                <div>
                  <h4>{t("Legal address")}:</h4>
                  <div>
                    <Input
                      fluid
                      size="small"
                      placeholder={t("Legal address")}
                      value={address}
                      disabled
                    />
                  </div>
                </div>
                <div>
                  <h4>{t("Company name")}:</h4>
                  <div>
                    <Input
                      fluid
                      size="small"
                      placeholder={t("Company name")}
                      value={company}
                      disabled
                    />
                  </div>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Checkbox
                    label={t("I agree to the processing of personal data")}
                    checked={checked}
                    onChange={(e, d) => {
                      setChecked(d.checked)
                    }}
                  />
                </div>
              </>
            ) : (
              <></>
            )}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 10,
              }}
            >
              <Button
                content={t("Back to")}
                negative
                onClick={() => {
                  history.push("/")
                  onExportSaveErrMsg("")
                  onExportSaveScssMsg("")
                  setActive(false)
                  setChecked(false)
                  setIinOrBin("")
                }}
              />
              <Button
                content={t("Next step")}
                positive
                onClick={() => {
                  setStep(step + 1)
                }}
                disabled={errMsg || !scssMsg || !checked}
              />
            </div>
          </>
        )}
        {step === 1 && (
          <>
            <div>
              <h3>{t("Step") + " 2"}.</h3>
              <h5>{t("ECP")}.</h5>
            </div>
            <Divider />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 10,
                alignItems: "center",
              }}
            >
              <ECPcomponent
                setIinOrBin={setLogin}
                visible={x509}
                setX509={setX509}
                setStep={setStep}
                step={step}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: 10,
              }}
            >
              <Button
                content={t("Back to")}
                negative
                onClick={() => {
                  onExportSaveErrMsg("")
                  onExportSaveScssMsg("")
                  setActive(false)
                  setChecked(false)
                  setIinOrBin("")
                  setChecked(false)
                  setStep(step - 1)
                }}
              />
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <div>
              <div>
                <h3>{t("Step") + " 3"}.</h3>
                <h5>{t("Personal data")}.</h5>
              </div>
              <Divider />
              <h4 style={{ marginTop: 10 }}>{t("Login")}:</h4>
              <div>
                <Input
                  fluid
                  size="small"
                  placeholder={t("Login")}
                  value={login}
                  disabled
                  type="number"
                />
              </div>
              <h4 style={{ marginTop: 10 }}>{t("Password")}:</h4>
              <div>
                <Input
                  fluid
                  size="small"
                  placeholder={t("Password")}
                  value={pass}
                  type={"password"}
                  onChange={(e, d) => {
                    setPass(d.value)
                  }}
                />
              </div>
              <h4 style={{ marginTop: 10 }}>{t("Confirm password")}:</h4>
              <div>
                <Input
                  fluid
                  size="small"
                  placeholder={t("Confirm password")}
                  value={confirmPass}
                  type={"password"}
                  onChange={(e, d) => {
                    setConfirmPass(d.value)
                  }}
                  disabled={pass === ""}
                  error={pass !== confirmPass}
                />
              </div>
              <h4 style={{ marginTop: 10 }}>{t("Email")}:</h4>
              <div>
                <Input
                  fluid
                  size="small"
                  placeholder={t("Email")}
                  value={email}
                  onChange={(e, d) => {
                    setEmail(d.value)
                  }}
                  type="email"
                />
              </div>
              <h4 style={{ marginTop: 10 }}>{t("phoneNumber")}:</h4>
              <div>
                <Input
                  fluid
                  size="small"
                  placeholder={t("phoneNumber")}
                  value={number}
                  onChange={(e, d) => {
                    setNumber(d.value)
                  }}
                  type={"number"}
                />
              </div>
              <p></p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 10,
                }}
              >
                <Button
                  content={"Back to"}
                  negative
                  onClick={() => {
                    setConfirmPass("")
                    setPass("")
                    setLogin("")
                    setEmail("")
                    setStep(step - 1)
                  }}
                />
                <Button
                  content={t("Complete")}
                  positive
                  onClick={handleSubmit}
                  disabled={
                    pass !== confirmPass &&
                    pass === "" &&
                    login === "" &&
                    email === "" &&
                    number === ""
                  }
                />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default RegistrationComponent
